import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vimeo-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM383.8 181.6c1.9-41.6-13.6-63-46.5-64-44.3-1.4-74.4 23.6-90.1 75.1 19.6-8.4 48.6-10.6 45.2 22.2-0.9 11.1-8.1 27.1-21.5 48.3-37.2 58.7-46.3 39.1-66.8-90.5-5.8-36.5-21.1-53.5-46-51.1-22 2-57.2 38-94.1 70.4l15 19.4c14.3-10.1 22.7-15.1 25.1-15.1 20.8 0 31.5 54.1 56.7 146.4 12.9 34.4 28.6 51.6 47.3 51.6 30.1 0 66.9-28.3 110.4-84.8 42.1-54.1 63.9-96.8 65.3-127.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vimeo-square.js
// module id = 1077
// module chunks = 0